import React from "react";
import About from "./About/About";
import BackGroundImg from "./BackGroundImg/BackGroundImg";
import Contact from "./Contact/Contact";
import Header from "./Header/Header";
import BurgerMenu from "../BurgerMenu/BurgerMenu";
import Navbar from "../Navbar/Navbar";
import { useMobile } from "../../context/MobileContext";
import "./Home.scss";
import AboutAdv from "./AboutAdv/AboutAdv";

const Home = () => {
  const { isMobile } = useMobile();
  const isAdvActive = process.env.IS_ADV_ACTIVE === "true";

  return (
    <>
      {isMobile ? <Navbar /> : <BurgerMenu />}
      <BackGroundImg />
      <Header />
      <About />
      <AboutAdv />
      <Contact />
    </>
  );
};

export default Home;
